
/**
 * Returns array of properties that have been altered between two versions of an object.
 * Expectation is that oldObject and newObject were once the same before one was altered.
 * @param oldObject - Original version of Object
 * @param newObject - New version of Object
 * @param checkMissingFields - Whether to include fields that were added/removed in the returned list of altered fields
 * @returns - Array of fields that were altered between new and original versions of Object
 */
export function getChangedValuesFromObject(oldObject, newObject, checkMissingFields = false)
{
  if(!oldObject || !newObject)
  {
    return [];
  }
  let changedFieldArr = [];
  const oldObjDictionary = Object.entries(oldObject);
  const newObjKeys = Object.keys(newObject);
  for (const [key, value] of oldObjDictionary) {
    if(newObject.hasOwnProperty(key))
    {
      if(newObject[key] !== value)
      {
        changedFieldArr.push(key);
      }

      // Remove from newObjKeys to know which exist
      let index = newObjKeys.indexOf(key);
      if(index !== -1)
      {
        newObjKeys.splice(index, 1);
      }
    }
    else if(checkMissingFields)
    {
      // Field in oldObject does not exist in newObject
      changedFieldArr.push(key);
    }
  }
  if(checkMissingFields && newObjKeys?.length > 0)
  {
    // Remaining newObjKeys that were not filtered, meaning
    // field in newObject does not exist in oldObject
    changedFieldArr = [...changedFieldArr, ...newObjKeys];
  }

  return changedFieldArr;
}

/**
 * Determines which fields have been altered and builds a string to save to the Audit Log from them
 * @param featureFieldsToBeSaved - An object representing which fields have been changed in a Key:BooleanValue format.
 * @returns - String of altered fields to enter into the Audit Log
 */
export function getLogForFieldUpdatesOnExistingFeature(featureFieldsToBeSaved) {
  let changeString = "";
  for (const [key, value] of Object.entries(featureFieldsToBeSaved)) {
    if(key !== "Status" && value === true)
    {
      const addComma = changeString.length > 0 ? ", " : "";
      changeString += `${addComma}${key}`;
    }
  }
  changeString = changeString.length > 0 ? `The following fields were modified: ${changeString}.`: ``;
  return changeString;
}



